import { RepaymentStrategy as Domain } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import update from './update';
import propertyApi from './property';
import endowmentApi from './endowment';
import investmentApi from './investment';

const repaymentStrategyAPI = (caseEndpoint: string) => ({
  update: (repaymentStrategy: Partial<Domain>) => update(`${caseEndpoint}/repayment-strategy`, repaymentStrategy),
  property: propertyApi(`${caseEndpoint}/repayment-strategy`),
  endowment: endowmentApi(`${caseEndpoint}/repayment-strategy`),
  investment: investmentApi(`${caseEndpoint}/repayment-strategy`),
});

export default repaymentStrategyAPI;
